export const config = {
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token 9b5ff0a046afe0a57a234e674eb8411792a210eb',
        'Accept': 'application/json'
    }
};